import store from '@/store'

export default {
    inserted(el, binding, vnode) {
        const { value } = binding
        const permissions = store.getters && store.getters.permissions
        if (value && value instanceof Array && value.length > 0) {
            const permissionValues = value
            const hasPermission = permissions.some(permission => {
                return permissionValues.includes(permission)
            })

            if (!hasPermission) {
                el.parentNode && el.parentNode.removeChild(el)
            }
        } else {
            throw new Error(`need permissions! Like v-permission="['admin','editor']"`)
        }
    }
}



// WEBPACK FOOTER //
// ./src/directive/permission/permission.js